import Vue from 'vue';
import Axios from 'axios';
import Form from '../form/form';

export default function () {
  const personalForms = [].slice.call(document.querySelectorAll('.quiz-block'));

  if (personalForms.length !== 0) {
    personalForms.forEach((personal) => {
      const objectData = personal.getAttribute('data-data');
      const object = window.formsData[`${objectData}`];
      new Vue({
        el: personal,
        delimiters: ['${', '}}'],
        data: {
          totalQuestions: 0,
          title: '',
          answers: [],
          showForm: false,
          quizes: null,
          currentQuiz: 0,
          selectedAnswers: [],
        },
        components: {
          personalForm: Form(object),
        },
        computed: {
          progress() {
            return ((this.currentQuiz + 1) / this.totalQuestions) * 100;
          },
        },
        methods: {
          renderQuiz() {
            const current = this.quizes[this.currentQuiz];
            this.title = current.question;
            this.answers = current.answers;
          },
          selectAnswer(el) {
            this.selectedAnswers.push({
              question: this.title,
              answer: el.srcElement.textContent,
            });
            this.nextQuestion();
          },
          nextQuestion() {
            if (this.currentQuiz + 1 < this.quizes.length) {
              this.currentQuiz += 1;
              this.renderQuiz();
            } else {
              this.showForm = true;
              window.scrollTo({
                top: this.$el.offsetTop,
                behavior: 'smooth',
              });
            }
          },
          prevQuestion() {
            this.currentQuiz -= 1;
            this.renderQuiz();
          },
          changeAnswers() {
            this.currentQuiz = 0;
            this.showForm = false;
            this.renderQuiz();
            this.selectedAnswers = [];
          },
        },
        mounted() {
          const quiz = this.$el.querySelector('.quiz');
          Axios.get(quiz.getAttribute('data-quiz'))
            .then((response) => {
              this.quizes = response.data;
              this.totalQuestions = this.quizes.length;
              this.renderQuiz();
            });
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/quiz-block/quiz-block.js